export const getTerminalLoading = state => state.terminalReducer.isLoading;
export const getTerminalIsOpen = state => state.terminalReducer.isOpen;
export const getTerminalIsClosed = state => state.terminalReducer.isClosed;
export const getIsTerminalOpen = state => state.terminalReducer.isTerminalOpen;
export const getTerminalError = state => state.terminalReducer.error;
export const getTerminalStatus = state => state.terminalReducer.status;
